import * as RoutesModule from "./routes";
import store from "./store";

const Routes = { ...RoutesModule };

window.Routes = new Proxy(Routes, {
  get(target, prop) {
    const original = target[prop];
    return function(params = {}, ...args) {
      const view = store.getState().view;
      const extraParams = view === "admin" ? { view: view } : {};
      return original({ ...params, ...extraParams }, ...args);
    };
  }
});
